module.exports = __webpack_public_path__ + "static/FeatDetail-acfc1a8bd1067e8523d42bcbaebd2ea4.png";